import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { PagosService, ReportesService, OptionsService, AltaSolicitudesService, FundersService, ContribuyentesService, PaymentDetailsService, PAYMENT_DETAIL_CONFIG, InvoicePD } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import swal2 from 'sweetalert2';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
// [13/08/2026] Se retiró Bugsnag: el dashboard no se revisaba hace ~1 año.
declare var $;

@Component({
  selector: 'app-afinanciera',
  templateUrl: './afinanciera.component.html',
  styles: []
})
export class AfinancieraComponent implements OnInit {

  constructor(private _formBuilder: FormBuilder,
              public _optionsservice: OptionsService,
              public router: Router,
              public _solicitudesservice: AltaSolicitudesService,
              public _contribuyentesService: ContribuyentesService,
              public _reportesservice: ReportesService,
              public _fundersservice: FundersService,
              public _pagosservice: PagosService,
              // [01/10/2026] Servicio de ajustes detalles (Payment Details)
              private _paymentDetailsService: PaymentDetailsService) {}

  cols: any[];
  a = new Date();
  fecha: string;
  correo: string;
  facturas: any[] = [];
  selectedFac: any[];
  idp: string;
  idcontribuyente: string;
  idcontfinan: string;
  idc: string;
  contribuyentes: any [] = [];
  pago: any[] = [];
  supplierpaymentid = '';
  totalFac = 0;
  totalFacs = '0';
  totalFacsFormateado = '0';
  idu = '';
  cadenaproveedor: any[];
  nombrecadena: string[];
  financieras: any[] = [];
  contributor_from_id: string;
  contributor_to_id: string;
  cadenas: any[];
  cadenaso: any[] = [];
  currency = [];
  paymentTypes = [];
  // [22/09/2026] Catálogo de bancos para el ajuste de póliza contable (pago FONDEO).
  // El backend ahora exige params[:bank] en registros PROVEEDOR y FONDEO cuando
  // ACCOUNTING_GENERATION está activo, así que si hay bancos configurados se
  // vuelve obligatorio seleccionar uno antes de guardar el pago.
  selectedBank: string = '';
  banks: any[] = [];
  hayBancos = false;
  // [01/10/2026] Flag de ajustes detalles: controla si se usa el endpoint PD o el legacy
  usarAjustesDetalles: boolean = false;

  ngOnInit() {
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
    swal2.showLoading();

   // this.getAcceso('/pagos/afinanciera');

    this.a = new Date();

    (document.getElementById('npago') as HTMLInputElement).value = '';

    (document.getElementById('voucher') as HTMLInputElement).value = '';

    (document.getElementById('notas') as HTMLInputElement).value = '';

    this.totalFacs = '0';

    this.totalFacsFormateado = '0';

    this.selectedFac = [];

    this.facturas = [];

    this.correo = '';

    this.idp = '';

    this.totalFac = 0;

    this.selectedBank = '';

    this.idu = localStorage.getItem('id');

    // [29/09/2026] Carga del catálogo de bancos condicionada a DOS parámetros
    // generales: ACCOUNTING_GENERATION y ACCOUNTING_SPECIFIC_ACCOUNTS_MODE.
    // Solo cuando AMBOS están en 'SI' el back genera la póliza detallada por
    // cadena y banco, y por tanto se debe mostrar el selector y enviar bank.
    // Si cualquiera de los dos está en 'NO', no existe (404), o tiene otro
    // valor, se oculta el selector y se mantiene el flujo previo al ajuste.
    // catchError garantiza que un 404 del parámetro se trate como "diferente de SI".
    this.banks = [];
    this.hayBancos = false;
    forkJoin([
      this._solicitudesservice.getGeneralParam('ACCOUNTING_GENERATION').pipe(catchError(() => of(null))),
      this._solicitudesservice.getGeneralParam('ACCOUNTING_SPECIFIC_ACCOUNTS_MODE').pipe(catchError(() => of(null)))
    ]).subscribe(([accGeneration, accSpecificMode]: [any, any]) => {
      const generacionActiva = accGeneration && accGeneration['value'] === 'SI';
      const modoEspecifico = accSpecificMode && accSpecificMode['value'] === 'SI';
      if (!(generacionActiva && modoEspecifico)) {
        return;
      }
      this._pagosservice.getAcountigAcountBanks().subscribe(banksResp => {
        this.banks = banksResp;
        this.hayBancos = banksResp && banksResp.length > 0;
      });
    });

    this._pagosservice.getCadenas().subscribe( resp => {this.cadenas = resp; // console.log(this.cadenas);
      // tslint:disable-next-line: forin
        for ( const prop in this.cadenas ) {
       this.cadenaso.push( this.cadenas[prop].nombre_cadena);
         }
  this.cadenaso.sort();
} );
 
    this._fundersservice.getfundersfinancial().subscribe( resp => {this.financieras = resp; swal2.close();} );

    this.a.setMinutes( this.a.getMinutes() + this.a.getTimezoneOffset() );
    let montha = '' + (this.a.getMonth() + 1);
    let daya = '' + this.a.getDate();
    const yeara = this.a.getFullYear();

    if (montha.length < 2) {
        montha = '0' + montha;
    }
    if (daya.length < 2) {
        daya = '0' + daya;
    }

    this.fecha = [yeara, montha, daya].join('-');

    this.cols = [
      { field: 'folio_reporte', header: 'Folio Reporte' },
      { field: 'folio_factura', header: 'Folio Factura' },
      { field: 'uuid', header: 'UUID' },
      { field: 'importe_neto', header: 'Importe Neto' },
      { field: 'porcentaje_operado', header: 'Porcentaje Operado' },
      { field: 'emisor', header: 'Emisor' },
      { field: 'receptor', header: 'Receptor' },
      { field: 'moneda', header: 'Moneda' },
      { field: 'fecha_operacion', header: 'Fecha de operación' },
      { field: 'fecha_vencimiento', header: 'Fecha de vencimiento' },
      { field: 'fecha_emision', header: 'Fecha de emision' },
      { field: 'fecha_carga', header: 'Fecha de carga' },
      { field: 'estatus', header: 'Estatus' }
    ];

    this._solicitudesservice.getPaymentCurrency().subscribe( resp => this.currency = resp );

    this._solicitudesservice.getPaymentTypes().subscribe(resp => this.paymentTypes = resp);
    // [01/10/2026] Consultar flag de ajustes detalles para pago de fondeo
    this._paymentDetailsService.checkFlag(PAYMENT_DETAIL_CONFIG.PAGO_FONDEO.flag).subscribe(activo => {
      this.usarAjustesDetalles = activo;
      // [05/10/2026] Columnas PD: 12 columnas exactas según imagen del usuario
      if (activo) {
        this.cols = [
          { field: 'folio_reporte', header: 'Folio Reporte' },
          { field: 'folio_factura', header: 'Folio Factura' },
          { field: 'uuid', header: 'UUID' },
          { field: 'total_a_pagar', header: 'Total a Pagar' },
          { field: 'emisor', header: 'Emisor' },
          { field: 'receptor', header: 'Receptor' },
          { field: 'moneda', header: 'Moneda' },
          { field: 'fecha_operacion', header: 'Fecha Operación' },
          { field: 'fecha_vencimiento', header: 'Fecha Vencimiento' },
          { field: 'fecha_emision', header: 'Fecha Emisión' },
          { field: 'fecha_carga', header: 'Fecha Carga' },
          { field: 'estatus', header: 'Estatus' }
        ];
      }
    });
  }

  getAcceso(url) {
    let tieneacceso = false;
    this._optionsservice.getOptionsxUsuario(localStorage.getItem('id')).subscribe(resp2 => {
      // tslint:disable-next-line: forin
      for (const j in resp2 ) {
          if ( resp2[j].url === url ) {
            tieneacceso = true;
            break;
          }
        }
      if (!tieneacceso) {
        this.router.navigate(['/accesodenegado']);
      }
    });
  }

  getcorreo() {
    const idfunder = (document.getElementById('fondeador') as HTMLInputElement).value
    // [29/09/2026] Al cambiar de fondeador se limpia el banco previamente
    // seleccionado para no arrastrar un valor incorrecto si el nuevo fondeador
    // no permite auto-match.
    this.selectedBank = '';
    let nombreFondeador = '';
    for ( const prop in this.financieras ) {
      if ( this.financieras[prop].id_funder == idfunder ) {
      //  console.log(this.financieras[prop]);
        this.correo = this.financieras[prop].email_finan;
        this.contributor_from_id = this.financieras[prop].id_contribuyente;
        this.contributor_to_id = this.financieras[prop].id_cont_finan;
        nombreFondeador = this.financieras[prop].nombre_fondeador || '';
        break;

      }

    }
    this.facturas = [];
    // [29/09/2026] Auto-selección de banco por heurística de nombres.
    // Solo se activa si el ambiente tiene el selector visible (hayBancos=true,
    // es decir ACCOUNTING_GENERATION y ACCOUNTING_SPECIFIC_ACCOUNTS_MODE en 'SI').
    this.autoSeleccionaBanco(nombreFondeador);
  }

  /**
   * [29/09/2026] Intenta pre-seleccionar un banco del catálogo a partir del
   * nombre del fondeador, usando tres niveles de match con prioridad:
   *   1. Exacto (comparación directa en mayúsculas).
   *   2. Normalizado (sin acentos y sin el prefijo "BANCO " / "BCO ").
   *   3. Contains bidireccional (uno contiene al otro).
   *
   * Si ningún nivel produce un único match (sea por ausencia de match o por
   * ambigüedad con varios candidatos) se deja selectedBank vacío para que el
   * usuario elija manualmente y el botón GUARDAR permanezca deshabilitado por
   * la validación existente.
   */
  private autoSeleccionaBanco(nombreFondeador: string) {
    if (!this.hayBancos || !nombreFondeador) {
      this.selectedBank = '';
      return;
    }

    const normaliza = (s: string) => s
      .toUpperCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // sin acentos
      .replace(/^BANCO\s+/i, '')                        // quita prefijo "BANCO "
      .replace(/^BCO\s+/i, '')                          // quita prefijo "BCO "
      .trim();

    const fondOriginal = nombreFondeador.toUpperCase().trim();
    const fondNormalizado = normaliza(nombreFondeador);

    // Nivel 1: match exacto (sin normalizar).
    let candidatos = this.banks.filter(b => b && b.toUpperCase().trim() === fondOriginal);
    if (candidatos.length === 1) {
      this.selectedBank = candidatos[0];
      return;
    }

    // Nivel 2: match por nombre normalizado (sin acentos y sin "BANCO "/"BCO ").
    candidatos = this.banks.filter(b => b && normaliza(b) === fondNormalizado);
    if (candidatos.length === 1) {
      this.selectedBank = candidatos[0];
      return;
    }

    // Nivel 3: contains bidireccional sobre nombres normalizados.
    candidatos = this.banks.filter(b => {
      if (!b) { return false; }
      const bN = normaliza(b);
      return bN.includes(fondNormalizado) || fondNormalizado.includes(bN);
    });
    if (candidatos.length === 1) {
      this.selectedBank = candidatos[0];
      return;
    }

    // Sin match o ambigüedad: el usuario decide.
    this.selectedBank = '';
  }

  vaciafacturas() {
    this.facturas = [];
  }

  getTotal() {
    this.totalFac = 0;
    let tp = 0;
    if ( this.selectedFac.length === 0 ) {
      this.totalFac = 0;
    } else {
      // tslint:disable-next-line: forin
      for ( const prop in this.selectedFac ) {
      //  this.totalFac = this.totalFac + parseFloat(this.selectedFac[prop].importe_neto);
        tp = tp + parseFloat(this.selectedFac[prop].importe_neto.replace(/,/g, ''));
      }
    }
   // this.totalFacs = this.totalFac.toFixed(2);
    this.totalFacs = tp.toFixed(2);
    this.totalFacsFormateado = tp.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  muestraFacturas() {
    if (!(document.getElementById('fondeador') as HTMLInputElement).value) {
        swal2.fire('Debe seleccionar un fondeador','','info');
        return
    }
    if (!(document.getElementById('cadena') as HTMLInputElement).value) {
      swal2.fire('Debe seleccionar una empresa','','info');
      return
    }
    // [22/09/2026] Valida el banco antes de consultar facturas para no dejar seleccionar
    // el detalle si al momento de guardar el back va a rechazar el pago por falta de bank.
    if (this.hayBancos && !this.selectedBank) {
      swal2.fire('Debe seleccionar un banco', '', 'info');
      return;
    }
    const moneda: any = document.getElementById('moneda');
    const valormoneda = moneda.options[moneda.selectedIndex].value;
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
 swal2.fire({
  title: 'Cargando',
  allowOutsideClick: false
});
    swal2.showLoading();
  //  console.log(this.idc);
  let idc =  (document.getElementById('cadena') as HTMLInputElement).value;
  let idf =  (document.getElementById('fondeador') as HTMLInputElement).value;
    // [01/10/2026] Bifurcación: si ajustes detalles está activo, consultar endpoint PD
    if (this.usarAjustesDetalles) {
      this._paymentDetailsService.getInvoicesPD(
        Number(this.contributor_from_id), Number(this.contributor_to_id),
        PAYMENT_DETAIL_CONFIG.PAGO_FONDEO.tipoRegistroPago
      ).subscribe(resp => {
        swal2.close();
        this.facturas = this.mapearFacturasPD(resp);
        if (this.facturas.length === 0) {
          swal2.fire('No se encontraron Datos', '', 'error');
        }
      }, (err) => {
        swal2.close();
        console.log(err);
        // [01/10/2026] Diferenciar errores 422: flag inactivo → fallback a legacy
        if (this._paymentDetailsService.esFlagInactivo(err)) {
          this.usarAjustesDetalles = false;
          this.muestraFacturas();
          return;
        }
        const titulo = (err && err.status === 422)
          ? 'Error de configuración en ajustes detalles'
          : 'Ocurrió un error al consultar ajustes detalles';
        swal2.fire({
          title: titulo,
          text: '',
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }).then(res => {
          if (res.value) { this.ngOnInit(); }
        });
      });
      return;
    }
    this._fundersservice.getcompanyfacturasxfunder( idc, valormoneda, idf ).subscribe( resp => {
                                                                                              swal2.close();
                                                                                              this.facturas = resp;
                                                                                              if ( this.facturas.length === 0 ) {
                                                                                              swal2.fire(
                                                                                                'No se encontraron Datos',
                                                                                                '',
                                                                                                'error'
                                                                                              );
                                                                                            }
    } , (err) => {
      swal2.close();
     // console.clear();
      swal2.fire({
        title: 'Ocurrio un error',
        text: '',
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }). then ( res => {
        if ( res.value ) {
          window.location.reload();
        }
      } );
     }  );

  }

  /**
   * [05/10/2026] Mapea facturas del endpoint PD al formato de tabla con 12 columnas de la imagen.
   * Filtra facturas ya pagadas y formatea montos con comas para compatibilidad con getTotal().
   * Se mantiene importe_neto mapeado desde total_a_pagar para getTotal().
   */
  mapearFacturasPD(facturas: InvoicePD[]): any[] {
    return facturas
      .filter(f => f.payment_status !== 'PAGADO')
      .map(f => ({
        id_factura: f.invoice_id,
        folio_reporte: f.folio_reporte,
        folio_factura: f.folio_factura,
        uuid: f.uuid,
        total_a_pagar: this._paymentDetailsService.formatearMonto(f.total_a_pagar),
        emisor: f.emisor,
        receptor: f.receptor,
        moneda: f.moneda,
        fecha_operacion: f.fecha_operacion,
        fecha_vencimiento: f.fecha_vencimiento,
        fecha_emision: f.fecha_emision,
        fecha_carga: f.fecha_carga,
        estatus: f.estatus_factura,
        // [05/10/2026] importe_neto se mantiene para compatibilidad con getTotal()
        importe_neto: this._paymentDetailsService.formatearMonto(f.total_a_pagar),
        es_parcial: f.payment_status === 'PARCIAL'
      }));
  }

  guardar() {

    if (this.selectedFac.length === 0) {

      swal2.fire(
        'Debe seleccionar al menos una Factura',
        '',
        'error'
      );

    } else {

      const tpago: any = document.getElementById('tdpago');
      const moneda: any = document.getElementById('moneda');

      const valortpago = tpago.options[tpago.selectedIndex].value;
      const valormoneda = moneda.options[moneda.selectedIndex].value;

      // [22/09/2026] Ajuste de póliza contable para pago de FONDEO.
      // El backend lee params[:bank] a nivel raíz del payload (fuera del objeto
      // payment), tal como especifica la sección 4.2 del ajuste de póliza contable.
      // Enviarlo dentro de payment provoca el error:
      //   "Se debe indicar el banco (params[:bank]) para generar el asiento
      //    de banco del pago de fondeo".
      const payment: any = {
        payment_date: (document.getElementById('fecha') as HTMLInputElement).value,
        payment_number: (document.getElementById('npago') as HTMLInputElement).value,
        payment_type: valortpago,
        currency: valormoneda,
        amount: this.totalFacs,
        email_cfdi: (document.getElementById('correo') as HTMLInputElement).value,
        notes: (document.getElementById('notas') as HTMLInputElement).value,
        voucher: (document.getElementById('voucher') as HTMLInputElement).value,
        contributor_from_id: this.contributor_from_id,
        contributor_to_id: this.contributor_to_id
      };

      const params: any = {
        payment_source: 'FONDEO',
        invoices: [],
        payment: payment
      };
      if (this.hayBancos && this.selectedBank) {
        params.bank = this.selectedBank;
      }

      // tslint:disable-next-line: forin
      for (const prop in this.selectedFac) {
        params.invoices[prop] = {id: this.selectedFac[prop].id_factura.toString() };
      }
      swal2.fire({
        title: 'Cargando',
        allowOutsideClick: false
   });
      swal2.showLoading();
       //console.log(params);
      this._pagosservice.aplicarPagoRAWproveedor(params).subscribe( resp => {
        swal2.close();
        swal2.fire({
          title: 'La información se registró',
          text: 'con éxito',
          icon: 'success',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {

          if ( res.value ) {
            this.ngOnInit();
          }

        } );

      }, (err) => {
        swal2.close();
        console.log(err);
        swal2.fire({
          title: 'Ocurrio un error',
          text: err.error.errors[0],
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {
          if ( res.value ) {
            this.ngOnInit();
          }
        } );
       } );

    }


  }

}







